import './styles.scss';

import React, {PropsWithChildren, useEffect, useRef, useState} from 'react';

import useWindowSize from '../../../hooks/useWindowSize';

interface AppAccordionProps extends PropsWithChildren {
    title: string;
    minHeight?: number;
    onCreate?: (value: number) => void;
}

export const AppAccordion = ({title, children, minHeight = 0, onCreate}: AppAccordionProps) => {
    const {width} = useWindowSize();
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [contentHeight, setContentHeight] = useState(0);
    const contentRef = useRef<HTMLDivElement>(null);

    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };

    const updateHeight = () => {
        if (contentRef.current) {
            const contentHeight = contentRef.current.scrollHeight;
            const newHeight = contentHeight > minHeight ? contentHeight : minHeight;

            setContentHeight(isOpen ? newHeight : 0);
        }
    };

    useEffect(updateHeight, [width, isOpen, minHeight]);

    useEffect(() => {
        if (onCreate && contentRef.current) {
            onCreate(contentRef.current.scrollHeight);
        }
    }, [contentRef.current, width]);

    return (
        <div className={`app-accordion ${isOpen ? 'open' : ''}`}>
            <div className='app-accordion__header' onClick={toggleAccordion}>
                <div className='app-accordion__title'>{title}</div>
                <div className='app-accordion__icon' />
            </div>
            <div className='app-accordion__wrapper' ref={contentRef} style={{height: contentHeight + 'px'}}>
                <div className='app-accordion__content'>{children}</div>
            </div>
        </div>
    );
};
